import { Link } from 'react-router-dom';
import type { ActionListItem, ActionMissing, ChecklistItemDto, GroupProgress } from '@tww/shared';
import { ACTION_STATUS_LABELS, dueLabel, fmtDate, totalProgress } from '@tww/shared';
import { ProgressStrip, StatusPill } from '../../ui/basics';

export function ActionStatusPill({ status, label }: { status: ActionListItem['status']; label?: string }) {
  return <StatusPill code={status} label={label ?? ACTION_STATUS_LABELS[status]} />;
}

/** Fortschrittsstreifen je Gewerk mit Prozent */
export function ActionProgress({ progress, pct }: { progress: GroupProgress[]; pct?: boolean }) {
  const t = totalProgress(progress);
  return <ProgressStrip segments={progress.map((g) => ({ done: g.done, total: g.total, late: g.late > 0, name: g.name }))} pct={pct === false ? undefined : t.pct} />;
}

export function MissingText({ m }: { m: ActionMissing }) {
  return <span className={m.ok ? 'ok' : m.late ? 'miss' : ''}>{m.text}</span>;
}

/** Aktionszeile: Partner · Ort mit Unterzeile */
export function ActionCell({ a, sub }: { a: ActionListItem; sub?: string }) {
  return (
    <>
      <Link className="link" to={`/aktionen/${a.id}`}>
        {a.label}
      </Link>
      <span className="sm">{sub ?? [a.code, a.type_label].filter(Boolean).join(' · ')}</span>
    </>
  );
}

export function DueCell({ item }: { item: Pick<ChecklistItemDto, 'state' | 'effective_due' | 'late' | 'optional'> }) {
  const d = dueLabel(item);
  const cls = d.cls === 'late' ? 'miss' : d.cls === 'done' ? 'ok' : d.cls === 'due' ? '' : 'mut';
  return <span className={`due ${cls}`}>{d.text}</span>;
}

/** Unterzeile eines Checklistenpunkts ohne bloße Zustandswörter („erledigt“, „Ja“); den Zustand zeigen Haken und Frist-Spalte */
const STATE_WORD = /^(?:Status:\s*)?(erledigt|ja|nein|nicht benötigt|benötigt|offen)$/i;
export function cleanSummary(s: string | null | undefined): string {
  if (!s) return '';
  return s
    .split(' · ')
    .filter((p) => !STATE_WORD.test(p.trim()))
    .map((p) => (/^Erledigt\b/.test(p) ? 'e' + p.slice(1) : p))
    .join(' · ');
}

export const fmtRange =(a: { date: string | null; date_end: string | null }) => (a.date ? (a.date_end && a.date_end !== a.date ? `${fmtDate(a.date).slice(0, 6)} bis ${fmtDate(a.date_end)}` : fmtDate(a.date)) : 'Termin offen');

export const ROLE_SHORT: Record<string, string> = { forst: 'Forst', flaeche: 'Fläche', projekt: 'Projekt', vorstand: 'Vorstand', admin: 'Admin' };
